import { Observer } from 'mobx-react-lite'
import { Form, FormField } from '@/Core/UI/Form'
import Tabs from '@/Core/UI/Tabs'
import { FormRow, FormSection } from '@/Ship/Components/Form/FormSection'
import { ChangePasswordTab } from '../Components/ChangePasswordTab'
import { UserPhotoField } from '../Components/UserPhotoField'
import { UserPhotoView } from '../Components/UserPhotoView'
import { UserNameFields } from '../Components/UserNameFields'
import { UserStatusField } from '../Components/UserStatusField'

export const UserEditTemplate = ({ formContext }: any) => {
    const tabItems = [
        {
            label: 'Основна інформація',
            key: 'general',
            children: (
                <Form formContext={formContext}>
                    <FormSection>
                        <Observer>
                            {() =>
                                formContext.isEditable ? (
                                    <UserPhotoField formContext={formContext} />
                                ) : (
                                    <UserPhotoView formContext={formContext} />
                                )
                            }
                        </Observer>
                    </FormSection>

                    <Observer>
                        {() =>
                            formContext.values?.id > 0 ? (
                                <FormSection>
                                    <UserStatusField formContext={formContext} />
                                </FormSection>
                            ) : null
                        }
                    </Observer>

                    <FormSection>
                        <UserNameFields formContext={formContext} />
                    </FormSection>

                    <FormSection>
                        <FormRow>
                            <FormField name="phone" />
                            <FormField name="email" />
                            <Observer>
                                {() => (!(formContext.values?.id > 0) ? <FormField name="plainPassword" /> : null)}
                            </Observer>
                        </FormRow>
                    </FormSection>

                    <FormSection>
                        <FormRow>
                            <FormField name="roles" />
                            <FormField name="position" />
                            <FormField name="externalCode" />
                        </FormRow>
                    </FormSection>
                </Form>
            ),
        },
        {
            label: 'Змінити пароль',
            key: 'password',
            children: (
                <ChangePasswordTab
                    key={String(formContext.values?.uuid || formContext.values?.id)}
                    userId={formContext.values?.uuid || formContext.values?.id}
                />
            ),
            depFn: () => formContext.values?.id > 0,
        },
    ]

    return <Tabs items={tabItems} />
}
